var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcpiViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#e04444;}.cls-3{fill:#ff7e74;}.cls-4{fill:#ffe1d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.21,
    y: 0.23,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.21,
    y: 0.23,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hcpi_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.87,
    y: 0.26,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.8,
    y: 74.92,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.79,269.39v314a17,17,0,0,1-17.26,16.84H18.08A17,17,0,0,1,.83,583.42V169.25a17,17,0,0,1,17.25-16.84H261.9a17.7,17.7,0,0,1,5.85,1l112.49,109A16.47,16.47,0,0,1,381.79,269.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.24,262.42H285.18a17.27,17.27,0,0,1-17.43-17.09V153.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.46,
    y: 371.68,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.96 1.44) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.57,
    y: 518.34,
    width: 133.75,
    height: 36.54,
    rx: 12,
    transform: "translate(-4.08 0.96) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.9,
    y: 298.6,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.4 1.43) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.01,
    y: 444.77,
    width: 261.49,
    height: 36.54,
    rx: 12,
    transform: "translate(-3.51 1.44) rotate(-0.44)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcpiViewEntries);
export default __webpack_public_path__ + "static/media/hcpi_view_entries.9aaa4e38b3f03e9654c35066c5f698c9.svg";
export { ForwardRef as ReactComponent };